module.exports = __webpack_public_path__ + "iot_data/img/cropped-Integral_logo.7bc9340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cropped-Integral_logo.png
// module id = 4tY/
// module chunks = 1